/* KOSZYK-89 · prezenty 600 / 1500 zł, wersja prosta (8.10.2026).
   Rysuje [data-jp-slot] z danych data-jp-cfg (snippets/jadore-prezenty-pasek.liquid).
   Progi są w groszach PLN; dla innej waluty koszyka przeliczamy je kursem Shopify.currency.rate.
   Po zmianie koszyka bierzemy świeże data-jp-cfg z HTML sekcji (z odpowiedzi koszyka albo ?sections=)
   i synchronizujemy atrybut koszyka „Prezent” (1 / 2 / pusty) przez /cart/update.js. */
(() => {
  if (window.jpPrezenty) return;

  const T = {
    pl: {
      brakDostawa: 'Brakuje Ci {k} do darmowej dostawy.',
      maszDostawe: 'Masz darmową dostawę.',
      dodaj: 'Dodaj {k}, a dołączymy prezent od nas.',
      jeden: 'Prezent od nas ✓',
      jedenDalej: 'Jeszcze {k} do drugiego prezentu.',
      jedenKoniec: 'Dołączymy go do paczki.',
      dwa: '2 prezenty od nas ✓',
      dwaKoniec: 'Dołączymy je do paczki.',
      stDostawa: 'Darmowa dostawa',
      stPrezent: 'Prezent',
      stDrugi: 'Drugi prezent',
      regulamin: 'Regulamin',
      oszczedzasz: 'Oszczędzasz {k}',
      zDostawa: 'darmowa dostawa',
      zPrezent: 'prezent od nas',
      zPrezenty: '2 prezenty od nas',
      zysk: 'Zyskujesz łącznie {k}',
      zyskBezKwoty: 'Zyskujesz:',
      aria: 'Postęp do darmowej dostawy i prezentów',
    },
    en: {
      brakDostawa: 'You are {k} away from free delivery.',
      maszDostawe: 'You have free delivery.',
      dodaj: 'Add {k} and we will include a gift from us.',
      jeden: 'Gift from us ✓',
      jedenDalej: '{k} left until your second gift.',
      jedenKoniec: 'We will add it to your parcel.',
      dwa: '2 gifts from us ✓',
      dwaKoniec: 'We will add them to your parcel.',
      stDostawa: 'Free delivery',
      stPrezent: 'Gift',
      stDrugi: 'Second gift',
      regulamin: 'Terms and conditions',
      oszczedzasz: 'You save {k}',
      zDostawa: 'free delivery',
      zPrezent: 'gift from us',
      zPrezenty: '2 gifts from us',
      zysk: 'You save {k} in total',
      zyskBezKwoty: 'You receive:',
      aria: 'Progress towards free delivery and gifts',
    },
  };

  const IKONA = {
    dostawa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>',
    prezent: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3 9h18M12 9v11M12 9c-1.5-3-5-4-5-1.5S10 9 12 9zM12 9c1.5-3 5-4 5-1.5S14 9 12 9z"/></svg>',
    prezenty: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1.5" y="10" width="9.5" height="9.5" rx="1"/><path d="M6.25 10v9.5M1.5 13h9.5M6.25 10c-.9-1.8-3-2.2-3-.7s2 .7 3 .7zM6.25 10c.9-1.8 3-2.2 3-.7s-2 .7-3 .7z"/><rect x="13" y="10" width="9.5" height="9.5" rx="1"/><path d="M17.75 10v9.5M13 13h9.5M17.75 10c-.9-1.8-3-2.2-3-.7s2 .7 3 .7zM17.75 10c.9-1.8 3-2.2 3-.7s-2 .7-3 .7z"/></svg>',
  };

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cfgOf = (el) => {
    try {
      return JSON.parse(el.getAttribute('data-jp-cfg'));
    } catch (e) {
      return null;
    }
  };
  const kurs = (c) => (c.waluta === 'PLN' ? 1 : Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 0);
  const zl = (cents) => {
    const v = Math.max(0, Math.ceil(cents));
    try {
      return FoxTheme.Currency.formatMoney(v, FoxTheme.settings.moneyFormat);
    } catch (e) {
      return (v / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  };
  /* Progi na przystankach bez groszy: „600 zł”, nie „600,00 zł”. */
  const zlProg = (cents) => zl(cents).replace(/[,.]00(?=\D|$)/, '').replace(/(\d)[.\s\u00a0](\d{3})(?!\d)/, '$1$2');
  const t = (c, k, kw) => {
    const s = (T[c.jezyk === 'pl' ? 'pl' : 'en'] || T.pl)[k];
    return kw === undefined ? esc(s) : esc(s).replace('{k}', '<strong>' + esc(kw) + '</strong>');
  };

  /* Stan koszyka: kwoty w walucie koszyka, progi przeliczone. */
  const stan = (c) => {
    const r = kurs(c);
    const pl = c.kraj === 'PL' && c.waluta === 'PLN';
    const p1 = Math.round(c.prog1 * r);
    const p2 = Math.round(c.prog2 * r);
    const prog2on = !!c.prog2on;
    let ile = 0;
    if (r > 0 && c.p >= p1) ile = 1;
    if (r > 0 && prog2on && c.p >= p2) ile = 2;
    const dostawaOk = pl && c.suma >= c.progD;
    return { r, pl, p1, p2, prog2on, ile, dostawaOk, prezentyWidoczne: c.p > 0 && r > 0 };
  };

  const kolo = (ok, ikona, obraz) =>
    `<span class="jp-st__kolo">${obraz ? `<img src="${esc(obraz)}" alt="" width="28" height="28" loading="lazy">` : IKONA[ikona]}</span>`;

  const przystanek = (c, od, doK, wartosc, ikona, obraz, opis, kwota) => {
    const w = doK > od ? Math.min(1, Math.max(0, (wartosc - od) / (doK - od))) : 1;
    const ok = wartosc >= doK;
    return `<li class="jp-st${ok ? ' jp-st--ok' : ''}"><span class="jp-st__linia"><span style="--jp-w:${w.toFixed(4)}"></span></span>${kolo(ok, ikona, obraz)}<span class="jp-st__opis"><b>${esc(opis)}</b>${esc(kwota)}</span></li>`;
  };

  const rysujPasek = (el, c) => {
    const s = stan(c);
    if (!c.n || (!s.pl && !s.prezentyWidoczne)) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    el.hidden = false;
    let tekst;
    if (s.pl && !s.dostawaOk) tekst = t(c, 'brakDostawa', zl(c.progD - c.suma));
    else if (!s.prezentyWidoczne) tekst = t(c, 'maszDostawe');
    else if (s.ile === 0) tekst = (s.pl ? t(c, 'maszDostawe') + ' ' : '') + t(c, 'dodaj', zl(s.p1 - c.p));
    else if (s.ile === 1 && s.prog2on) tekst = t(c, 'jeden') + ' ' + t(c, 'jedenDalej', zl(s.p2 - c.p));
    else if (s.ile === 1) tekst = t(c, 'jeden') + ' ' + t(c, 'jedenKoniec');
    else tekst = t(c, 'dwa') + ' ' + t(c, 'dwaKoniec');
    if (s.prezentyWidoczne && c.regulamin)
      tekst += ` <a class="jp-pasek__reg" href="${esc(c.regulamin)}">${t(c, 'regulamin')}</a>`;

    /* Linia pokazuje P (prezenty), ale do przystanku dostawy dochodzi także wtedy, gdy darmową dostawę
       dał koszyk z markami wyłączonymi z prezentów. */
    const L = T[c.jezyk === 'pl' ? 'pl' : 'en'];
    const wart = s.pl ? Math.max(c.p, Math.min(c.suma, c.progD)) : c.p;
    let st = '';
    let od = 0;
    if (s.pl) {
      st += przystanek(c, 0, c.progD, s.dostawaOk ? c.progD : c.suma, 'dostawa', '', L.stDostawa, zlProg(c.progD));
      od = c.progD;
    }
    if (s.prezentyWidoczne) {
      st += przystanek(c, od, s.p1, wart, 'prezent', c.obraz1, L.stPrezent, zlProg(c.prog1 * s.r));
      if (s.prog2on) st += przystanek(c, s.p1, s.p2, wart, 'prezenty', c.obraz2, L.stDrugi, zlProg(c.prog2 * s.r));
    }
    el.innerHTML = `<p class="jp-pasek__tekst" role="status" aria-live="polite">${tekst}</p><ol class="jp-pasek__tor" aria-label="${t(c, 'aria')}">${st}</ol>`;
  };

  const rysujZysk = (el, c) => {
    const s = stan(c);
    const czesci = [];
    let suma = 0;
    if (c.save > 0) {
      czesci.push(t(c, 'oszczedzasz', zl(c.save)).replace(/<\/?strong>/g, ''));
      suma += c.save;
    }
    if (s.dostawaOk && c.dostawa > 0) {
      czesci.push(t(c, 'zDostawa'));
      suma += c.dostawa;
    }
    if (s.ile > 0) {
      czesci.push(t(c, s.ile === 2 ? 'zPrezenty' : 'zPrezent'));
      if (c.wartoscPrezentu > 0) suma += Math.round(c.wartoscPrezentu * s.r) * s.ile;
    }
    if (!c.n || !czesci.length) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    let tekst = czesci.join(' · ');
    tekst = tekst.charAt(0).toUpperCase() + tekst.slice(1);
    const sumaHtml = suma > 0 ? t(c, 'zysk', zl(suma)) : t(c, 'zyskBezKwoty');
    el.hidden = false;
    el.innerHTML = `<span class="jp-zysk__sklad">${tekst}</span><span class="jp-zysk__suma">${sumaHtml}</span>`;
  };

  let wyslano = null;
  const synchronizujAtrybut = (c) => {
    const s = stan(c);
    const cel = s.ile > 0 ? String(s.ile) : '';
    document.querySelectorAll('input[data-jp-attr]').forEach((i) => (i.value = cel));
    if (wyslano === null) wyslano = c.prezent || '';
    if (wyslano === cel) return;
    wyslano = cel;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Prezent: cel } }),
    }).catch(() => {
      wyslano = null;
    });
  };

  const rysujWszystko = () => {
    const stany = new Set();
    let ostatni = null;
    document.querySelectorAll('[data-jp-slot]').forEach((el) => {
      const c = cfgOf(el);
      if (!c) return;
      if (el.getAttribute('data-jp-slot') === 'pasek') rysujPasek(el, c);
      else rysujZysk(el, c);
      stany.add([c.n, c.suma, c.p].join('/'));
      ostatni = c;
    });
    /* Atrybut tylko wtedy, gdy wszystkie sloty (szuflada i /cart) mają ten sam stan koszyka. */
    if (ostatni && stany.size === 1) synchronizujAtrybut(ostatni);
  };

  /* Przenosi świeże data-jp-cfg z HTML sekcji do slotów na stronie (nagłówek szuflady i pasek kasy
     nie są przerysowywane przez motyw). */
  const wezSekcje = (sekcje) => {
    Object.keys(sekcje || {}).forEach((id) => {
      const html = sekcje[id];
      const tu = document.getElementById('shopify-section-' + id);
      if (!html || !tu) return;
      const nowa = new DOMParser().parseFromString(html, 'text/html');
      tu.querySelectorAll('[data-jp-slot]').forEach((el) => {
        const zr = nowa.querySelector(`[data-jp-slot="${el.getAttribute('data-jp-slot')}"]`);
        if (zr) el.setAttribute('data-jp-cfg', zr.getAttribute('data-jp-cfg'));
      });
    });
  };

  let licznik = 0;
  const poZmianie = async (sekcje) => {
    const moje = ++licznik;
    const ids = [
      ...new Set(
        [...document.querySelectorAll('[data-jp-slot]')]
          .map((el) => el.closest('.shopify-section'))
          .filter(Boolean)
          .map((s) => s.id.replace('shopify-section-', ''))
      ),
    ];
    const brak = ids.filter((id) => !(sekcje && sekcje[id]));
    if (sekcje) wezSekcje(sekcje);
    rysujWszystko();
    if (!brak.length) return;
    try {
      const r = await fetch(`${window.location.pathname}?sections=${brak.map(encodeURIComponent).join(',')}`);
      if (r.ok && moje === licznik) {
        wezSekcje(await r.json());
        rysujWszystko();
      }
    } catch (e) {}
  };

  document.addEventListener('cart:updated', (e) => poZmianie(e.detail && e.detail.cart && e.detail.cart.sections));
  document.addEventListener('product-ajax:added', () => poZmianie(null));

  /* Motyw podmienia innerHTML /cart i całej szuflady (cart:refresh). Nowe, puste sloty rysujemy
     w tym samym zadaniu, przed malowaniem, więc pasek nie mruga. */
  new MutationObserver((zmiany) => {
    for (const z of zmiany)
      for (const n of z.addedNodes)
        if (n.nodeType === 1 && (n.matches('[data-jp-slot]') || n.querySelector('[data-jp-slot]'))) return rysujWszystko();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.jpPrezenty = { rysuj: rysujWszystko, odswiez: () => poZmianie(null) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rysujWszystko);
  else rysujWszystko();
})();
